<template>
  <a
    class="gifts-item"
    :class="[
      { 'gifts-item--unread': unread && !used },
      { 'gifts-item--used': used },
    ]"
    :href="used ? null : url"
  >
    <div class="gifts-item__avatar">
      <i v-if="type !== 'QA'" class="material-icons">stars</i>
      <i v-else class="material-icons">question_answer</i>
    </div>

    <div class="gifts-item__info">
      <h6 class="gifts-item__title">{{ title }}</h6>
      <div class="gifts-item__type">{{ typeName }}</div>
    </div>
    <div class="gifts-item__date">
      {{ timestamp | moment("calendar", null, { sameElse: "l LT" }) }}
    </div>
  </a>
</template>

<script>
export default {
  name: 'GiftsItem',
  props: {
    /**
     * 活動名稱
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * 類別代碼
     */
    type: {
      type: String,
      default: '',
    },
    /**
     * 類別名稱
     */
    typeName: {
      type: String,
      default: '',
    },
    /**
     * 時間戳記
     */
    timestamp: {
      type: Number,
      default: null,
    },
    /**
     * 是否已讀
     */
    unread: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否已參與
     */
    used: {
      type: Boolean,
      default: false,
    },
    /**
     * 活動連結
     */
    url: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
.gifts-item
  position: relative
  display: flex
  justify-content: flex-start
  align-items: stretch
  flex-direction: row
  flex-wrap: nowrap
  font-weight: 400
  user-select: none
  padding: 16px
  gap: 0px 12px

  &:not(:last-child)
    &::after
      content: ''
      position: absolute
      bottom: 0
      left: 68px
      right: 16px
      height: 0.5px
      background-color: rgba(142, 142, 142, 0.2527)

  &__avatar
    display: flex
    justify-content: center
    align-items: center
    align-self: center
    height: 40px
    border-radius: 8px
    background-color: #FFEA00
    flex: 0 0 40px

    .material-icons
      color: #333333

  &__info
    align-self: stretch
    text-align: left
    margin-right: auto

  &__title
    color: #333333
    font-weight: 600
    font-size: 0.875rem
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
    overflow: hidden
    text-overflow: ellipsis
    margin-bottom: 4px

  &__type,
  &__date
    color: #8E8E8E

  &__type
    font-size: 0.875rem

  &__date
    align-self: stretch
    font-size: 0.625rem
    text-align: right

  &--unread
    &::before
      content: ''
      position: absolute
      top: 50%
      left: 0px
      width: 4px
      height: 40px
      border-top-right-radius: 4px
      border-bottom-right-radius: 4px
      background-color: #FFEA00
      transform: translateY(-50%)
      z-index: 10

  &--used
    .gifts-item__avatar
      background-color: #F1F1F1

      .material-icons
        color: rgba(189, 189, 189, 0.6)
</style>
